// LAP-550 — Card Startups : header + items startup (image + meta + investisseurs)
import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import AddOpportunityAction from '../../_shared/AddOpportunityAction'
import CardHeader from '../../_shared/CardHeader'

export default function StartupsCard({ result = [] }) {
  const { t } = useTranslation('layout')
  return (
    <Box display="flex" flexDirection="column" height="100%">
      <CardHeader
        icon="/images/Startup.png"
        title={t('investments.markeet.startups.title')}
        subtitle={t('investments.markeet.startups.subtitle')}
      />
      <Box mt={2} height="100%" display="flex" flexDirection="column" gap={1.25} sx={{ overflow: 'auto' }}>
        {result.map((item, index) => (
          <Box
            key={index}
            display="flex"
            sx={{
              p: 1,
              borderRadius: 1.5,
              backgroundColor: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.05)',
            }}
          >
            <Box
              sx={{
                width: 88,
                height: 80,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                mr: 1.5,
                borderRadius: 1,
                backgroundColor: 'rgba(255,255,255,0.04)',
                flexShrink: 0,
              }}
            >
              <img src={item.image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </Box>
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
              <Box sx={{ fontWeight: 600, fontSize: 14 }}>{item.name}</Box>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
                <Box
                  sx={{
                    fontSize: 10,
                    px: 0.75,
                    py: 0.25,
                    borderRadius: 999,
                    backgroundColor: 'rgba(244,114,182,0.15)',
                    color: '#f9a8d4',
                  }}
                >
                  {item.sector}
                </Box>
                <Box
                  sx={{
                    fontSize: 10,
                    px: 0.75,
                    py: 0.25,
                    borderRadius: 999,
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    color: 'rgba(255,255,255,0.7)',
                  }}
                >
                  {item.localisation}
                </Box>
                <AddOpportunityAction
                  initialValues={{
                    name: item.name,
                    price: item.price,
                    sector: item.sector,
                    industry: item.localisation,
                    description: `${item.investor} ${t('investments.markeet.startups.investors')}`,
                  }}
                />
              </Box>
              <Box sx={{ mt: 0.75, fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>
                {t('investments.markeet.startups.amountSought')}:&nbsp;
                <Box component="span" sx={{ color: 'white', fontWeight: 600 }}>
                  {item.price} €
                </Box>
              </Box>
              <Box sx={{ fontSize: 11, color: 'rgba(255,255,255,0.55)' }}>
                {item.investor} {t('investments.markeet.startups.investors')}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
